module.exports = __webpack_public_path__ + "static/ColdCutter-661a8f99f0050af2ac9ce9d138eca26b.jpg";